/* tslint:disable */
/* eslint-disable */
// Generated using typescript-generator version 3.2.1263 on 2023-06-28 16:35:31.

export class UserData {
  familieneinkommen : number = 0;
  personenImHaushalt?: number = 1;
  miete?: number = 0;
  groesseWohnung?: number = 0;
  kitaKosten?: number = 0;
  kitaKostenGeschwister?: number = 0;
}
